<template>
  <div class="control">
    <div class="control__title">
      <div class="title">
        <div class="title-text">
          {{ title }}
        </div>
        <div class="control__helper">
          <div
            v-if="hintStatus"
            class="control__trigger"
            @mouseover="showHint = true"
            @mouseleave="showHint = false"
          >
            <img src="https://sirv.sirv.com/website/theme2/icon/question.svg" :alt="hint" />
          </div>
          <div v-show="showHint" class="hint">
            {{ hint }}
          </div>
        </div>
      </div>
    </div>
    <div class="control__action">
      <div class="control__choice">
        <div
          class="fakeoverlay"
          :class="{ disabled: !selectStatus }"
          @click="selectStatus = !selectStatus"
        />
        <div class="imageoptions">
          <div
            v-for="(item, i) in src"
            :key="`item${i}`"
            class="imageoptions__item"
            :class="[
              { active: i === active && selectStatus === true },
              { white: item.type === 'white' },
              { black: item.type === 'black' },
            ]"
            :style="`background-image: url(${item.url})`"
            @click="changeImage(i)"
          />
        </div>
      </div>
      <el-checkbox v-model="selectStatus" class="control__checkbox" @change="changeOptionCSS" />
    </div>
  </div>
</template>
<script>
import src from "@/assets/modelicon.json";
import { mapState } from "vuex";
export default {
  name: "ModelIconCSS",
  props: {
    title: {
      type: String,
      default: "",
    },
    default: {
      type: Number,
      default: 0,
    },
    hintStatus: {
      type: Boolean,
      default: true,
    },
    hint: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    status: {
      type: Boolean,
    },
    parameter: {
      type: String,
      default: "",
    },
    eventClick: {
      type: Boolean,
    },
  },
  data() {
    return {
      src: src,
      value: src[this.default],
      active: this.default,
      selectStatus: this.status,
      showHint: false,
    };
  },
  computed: {
    ...mapState(["clearOptionsCSS"]),
    getDefaultValue() {
      return this.default;
    },
  },
  watch: {
    clearOptionsCSS(val) {
      if (val) {
        this.selectStatus = false;
      }
    },
    eventClick(val) {
      this.selectStatus = val;
      this.value = this.default;
    },
    selectStatus(val) {
      if (val === true) {
        this.changeImage(this.active);
        this.changeOptionCSS();
      }
    },
    getDefaultValue(value) {
      this.active = value;
      this.changeImage(this.active);
    },
  },
  methods: {
    changeImage(i) {
      const index = i;
      let url = `url(${this.src[index].url})` || "";
      if (
        this.src[index] &&
        this.src[index].hiddenType &&
        this.src[index].hiddenType === "noicon"
      ) {
        url = "none";
      }
      this.active = index;
      this.value = url;
      this.changeOptionCSS();
    },
    changeOptionCSS() {
      const value = this.selectStatus === true ? `${this.value}` : "";
      const noIconValue = this.selectStatus === true && this.value === "none" ? "transparent" : "";
      this.$emit("changeOptionCSS", {
        type: this.type,
        parameter: `${this.parameter}`,
        separator: ":",
        value: value,
      });
      if (noIconValue === "none") {
        setTimeout(() => {
          this.$emit("changeOptionCSS", {
            type: this.type,
            parameter: `background-color`,
            separator: ":",
            value: noIconValue,
          });
        }, 500);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.imageoptions {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  &__item {
    max-width: 50px;
    width: 100%;
    height: 50px;
    margin: 0 2.5px 5px;
    object-fit: cover;
    cursor: pointer;
    padding: 5px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    border: 1px solid transparent;
    &.white {
      background-color: rgba(0, 0, 0, 0.3);
    }
    &.black {
      background-color: rgba(255, 255, 255, 0.3);
    }
    img {
      display: block;
      margin: 0 auto;
    }

    &.active.white {
      border-color: rgba(50, 123, 186, 0.9);
    }
    &.active.black {
      border-color: rgba(50, 123, 186, 0.9);
    }
  }
}
</style>
